module.exports = __webpack_public_path__ + "img/suyuan.4b187679.png";